
export class Player {
    public id: string;
    public key: string;
    public name: string;
    public lastSecondsOnField: number;
    public lastSecondsOfField: number;
    public totalSecondsOnField: number;
    public isOnField: boolean;
    public lastStartOnField?: string;
    public lastOnField?: string;
    public lastOfField?: string;

    public _editingName?: string;
    public _editing: boolean;
    public _timeOnField?: string;
    public _timeOffField?: string;    
    public _timeTotal?: string;
  }
  
  export class Match {
    public id: string;
    public opponent?: string;
    public homeCount: number;
    public awayCount: number;
    public homeGame?: boolean;
    public hasStarted: boolean;
    public isRunning: boolean;
    public totalSecondsPlayed: number;
    public lastStarted?: string;
    public matchPlayedTime: string;
    public players: Array<Player>;
    public created: string;
  }

  export class SpondMatch {
    public id: string;
    public heading: string;

    public alreadyExistsPlaymatch: boolean;
    public startTimestamp: string;
    public startTimestampLocale: string;
    public players: Array<SpondPlayer>;
  }

  export class SpondPlayer {
    public id: string;
    public name: string;
    public shortName: string;
  }

  
  export class SpondGroup {
    public id: string;
    public name: string;
    public shortName: string;
  }